/* eslint-disable camelcase */
/* eslint-disable no-param-reassign */
import { o } from 'odata';
import { authHub, errorHub } from '@codehq/aurora-app-core/src';

export default {
  parseId: (id) => {
    let i = id;
    if (Number.isNaN(id)) {
      i = `'${id}'`;
    }
    return i;
  },
  /**
  * Install the plugin
  */
  // eslint-disable-next-line no-unused-vars
  install(Vue, $store) {
    Vue.prototype.$odata = o;

    if (!o) {
      // eslint-disable-next-line no-console
      console.error('You have to install o.js');
      return;
    }

    const getConf = (token, organization) => ({
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        organizationid: `${organization?.id}`,
      }),
      onError: (x, e) => {
        if (e.status === 401) {
          authHub.$emit('user.unauthorized', e);
        } else {
          errorHub.$emit('network.error', e);
        }
      },
    });

    Object.defineProperties(Vue.prototype, {
      $o: {
        async get() {
          const { token_expires } = $store.state.auth;
          const { organization } = $store.state.organizations;
          const date1 = new Date(token_expires);
          const date2 = new Date();
          const expires = Math.abs(date2 - date1);
          if (expires < 60000) {
            await $store.dispatch('auth/REFRESH_auth');
          }
          const { token } = $store.state.auth;
          return o(`${process.env.VUE_APP_APIURL}/odata/`, getConf(token, organization));
        },
      },

    });
  },
};
